import { render, staticRenderFns } from "./BaseButtonSend.vue?vue&type=template&id=67ae3c00&scoped=true&"
import script from "./BaseButtonSend.vue?vue&type=script&lang=js&"
export * from "./BaseButtonSend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ae3c00",
  null
  
)

export default component.exports